"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderLayout = renderLayout;
exports.getLayoutDependents = getLayoutDependents;
exports.BmFormLayout = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _layoutRegistry = require("../../registry/layout-registry");

var _itemRenderer = require("../items/item-engine/item-renderer");

function renderLayout(info, items) {
  var layout = (0, _layoutRegistry.getLayout)(info.type);
  return layout.renderer(info, items);
}

function getLayoutDependents(info) {
  var layoutEngine = (0, _layoutRegistry.getLayout)(info.type);
  return layoutEngine.dependents(info);
}

var BmFormLayout = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmFormLayout, _BlueElement);

  var _super = (0, _createSuper2.default)(BmFormLayout);

  function BmFormLayout() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmFormLayout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.renderItem = _itemRenderer.renderItem;
    return _this;
  }

  (0, _createClass2.default)(BmFormLayout, null, [{
    key: "dependents",
    value: function dependents(_layout) {
      return [];
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        },
        items: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }]);
  return BmFormLayout;
}(_element.BlueElement);

exports.BmFormLayout = BmFormLayout;
